export const NAME = 'myinterests';

export const REQUEST_UPDATE_INTERESTS = 'REQUEST_UPDATE_INTERESTS';
export const SUCCESS_UPDATE_INTERESTS = 'SUCCESS_UPDATE_INTERESTS';
export const FAILURE_UPDATE_INTERESTS = 'FAILURE_UPDATE_INTERESTS';

export const RESET_FORM_SUBMIT_UPDATE_INTERESTS = 'RESET_FORM_SUBMIT_UPDATE_INTERESTS';

export const REQUEST_USER_CRITERIA = 'REQUEST_USER_CRITERIA';
export const RECEIVE_USER_CRITERIA = 'RECEIVE_USER_CRITERIA';
export const FAILURE_USER_CRITERIA = 'FAILURE_USER_CRITERIA';



// WEBPACK FOOTER //
// ./src/services/account/myinterests/constants.js